<template>
	<template v-if="isMobile">
		<details class="c-footer__section c-footer__details"
			:class="column.BaseViewModel.IsExpanded ? 'open' : ''">
			<summary class="c-footer__summary c-footer--padding-left-section-gutter">
				<h2 class="c-footer__title">{{ column.BaseViewModel.ColumnHeading }}</h2>
				<span class="c-footer__summary-toggle-icon">
					<ds-icon icon-name="chevron-down"></ds-icon>
				</span>
			</summary>

			<global-footer-column-content :column="column" :class="MOBILE_CSS_CLASSES">
				<slot></slot>
			</global-footer-column-content>
		</details>
	</template>


	<div v-else class="c-footer__section c-footer__col" :class="`c-footer__col-width-${column.BaseViewModel.ColumnWidth}`">
		<h2 class="c-footer__title">{{ column.BaseViewModel.ColumnHeading }}</h2>
		<global-footer-column-content :column="column">
			<slot></slot>
		</global-footer-column-content>
	</div>
</template>

<script setup lang="ts">
import { dsUseIsMobile, DsIcon } from '@coloplast/design-system';
import GlobalFooterColumnContent from './GlobalFooterColumnContent.vue';
import type { GlobalFooterColumn } from './GlobalFooter.types';
import "./GlobalFooter.scss";

const MOBILE_CSS_CLASSES = "c-footer--padding-bottom-section-side-gutter c-footer--padding-right-section-side-gutter c-footer--padding-left-section-gutter";
const { isMobile } = dsUseIsMobile(992);

export type GlobalFooterColumnProps = {
	column: GlobalFooterColumn,
}

defineProps<GlobalFooterColumnProps>();
</script>
